import React from "react";
import PredictionPage from "../../components/PredictionPage";

function AUDNZD() {
  return (
    <PredictionPage
      title="AUDNZD"
      content="This is the AUDNZD AI Trading Predictions page."
      canonical="/forex-minors/audnzd-ai-trading-predictions"
      categoryKey="nav.forexMinors"
      categoryPath="/forex-minors"
      symbol="AUDNZD"
    />
  );
}

export default AUDNZD;
